import React, {useEffect, useState} from 'react';
import {z} from 'zod';
import {useForm} from 'react-hook-form';
import {zodResolver} from '@hookform/resolvers/zod';
import {withRouter, resolveRoute} from '@computerrock/formation-router';
import {connect} from 'react-redux';
import './LoginModal.scss';
import * as adminActionType from '../adminActionTypes';
import routePaths from '../../routePaths';
import {setJwtToken} from '../../utils/saveAdminToken';

const loginSchema = z.object({
    identifier: z.string().email('Please enter a valid email address').min(1, 'Email is required'),
    password: z.string().min(8, 'Password must be at least 8 characters'),
});

const LoginModal = ({sendLogin, isLoading, error, jwtToken, user, history, dispatch}) => {
    const [apiError, setApiError] = useState(error ? 'E-Mail oder Passwort falsch' : '');

    const {
        register,
        handleSubmit,
        formState: {isValid, errors},
    } = useForm({
        resolver: zodResolver(loginSchema),
        defaultValues: {
            identifier: '',
            password: '',
        },
        mode: 'onChange',
    });

    const onSubmit = async data => {
        setApiError('');
        sendLogin(data);
    };

    useEffect(() => {
        if (error) {
            setApiError('E-Mail oder Passwort falsch');
        }
    }, [error]);

    useEffect(() => {
        if (jwtToken && user) {
            setJwtToken(jwtToken, dispatch, user.id);
            history.push(resolveRoute(routePaths.EXCEL_IMPORT, {}, {}));
        }
    }, [jwtToken, user, history, dispatch]);

    return (
        <div className="modal sski-admin-login-modal-container is-active">
            <div className="modal-background" />
            <div className="sski-admin-login-modal has-white-bg modal-card">
                <section className="modal-card-body">
                    <form onSubmit={handleSubmit(onSubmit)} method="post">
                        <div className="field">
                            <label className="label">Email</label>
                            <div className="control">
                                <input
                                    className={`input input-sski is-fullwidth ${errors.identifier ? 'is-danger' : ''}`}
                                    type="email"
                                    {...register('identifier', {
                                        onChange: () => setApiError(''),
                                    })}
                                />
                            </div>
                            {errors.identifier && <p className="help is-danger">{errors.identifier.message}</p>}
                        </div>
                        <div className="field mb-6">
                            <label className="label">Password</label>
                            <div className="control">
                                <input
                                    className={`input input-sski is-fullwidth ${errors.password ? 'is-danger' : ''}`}
                                    type="password"
                                    {...register('password', {
                                        onChange: () => setApiError(''),
                                    })}
                                />
                            </div>
                            {(errors.password || apiError) && <p className="help is-danger">{apiError}</p>}
                        </div>
                        <div className="field">
                            <div className="control">
                                <button
                                    type="submit"
                                    className={`button-sski button is-size-4 is-rounded is-fullwidth ${
                                        isLoading ? 'is-loading' : ''
                                    }`}
                                    disabled={!isValid || isLoading || !!apiError}
                                >
                                    Login
                                </button>
                            </div>
                        </div>
                    </form>
                </section>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        user: state.admin.user,
        jwtToken: state.admin.jwtToken,
        error: state.admin.error,
        isLoading: state.admin.isLoading,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        sendLogin: payload => dispatch({
            type: adminActionType.START_LOGIN_REQUEST,
            payload,
        }),
        dispatch, // Add dispatch to props
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginModal));
